import { axios } from '@/services/axios';

const getSpecialNumber = (specialNumberId) => {
    return axios.get(`/specialnumber/${specialNumberId}`);
};

export default getSpecialNumber;
